export default {
  clientData: {
    identificacion: '',
    tipoIdentificacion: '',
    email: '',
    celular: '',
    imagenCedula1: '',
    imagenCedula2: '',
  },
}
